import React from "react";
import { Outlet } from "react-router-dom";
import PortalLayout from "../nyafaz-ep/admin-shared/PortalLayout";
import PortalHeadHeader from "../enterprise-portal/components/PortalHeadHeader";
import NaturalsAdminSidebar from "./NaturalsAdminSidebar";
import { getProductBySlug } from "../enterprise-portal/utils/portalProducts";

const naturalsProduct = getProductBySlug("naturals");

const NaturalsAdminLayout = ({ hideSidebar = false, dashboardOnly = false }) => (
  <PortalLayout
    hideSidebar={hideSidebar}
    hideHeader={hideSidebar}
    dashboardOnly={dashboardOnly}
    portalId="nyafaz_naturals_admin"
    Sidebar={NaturalsAdminSidebar}
    Header={PortalHeadHeader}
  >
    <Outlet context={{ product: naturalsProduct }} />
  </PortalLayout>
);

export default NaturalsAdminLayout;
